import moment from 'moment'
export function duration_format(value,options={}) {
  const new_value = parseInt(value)
  if (!new_value) return options?.default || `00:00:00`;
  return moment.duration(value, options?.unit || "seconds").format(options?.format || "hh:mm:ss", {
    trim: options?.trim ?? false
  });
}